import React from "react"
import Layout from "../layout/Layout"
import SEO from "../components/seo/seo"
import styled from "styled-components"
import ContactMain from "../pagesParts/contact/ContactMain"
import PageHeader from "../components/pageHeader/PageHeader"

const StyledMainWrapper = styled.main`
  margin-top: 120px;
`

export default function ContactPage() {
  return (
    <Layout>
      <SEO
        title="Contact"
        description="Find Origin Restaurant in Addis Ababa (4 Kilo, behind Ambassador). Reach us on TikTok @originrestunant or call +251 911 121 314."
      />
      <StyledMainWrapper>
        <PageHeader
          heading="Contact"
          subheading="We’re based in Addis Ababa — 4 Kilo, behind Ambassador. Come through for flavorful chaofan, juicy steak sandwiches, classic hotdogs, crispy fries, and ice-cold drinks."
        />
        <ContactMain />
      </StyledMainWrapper>
    </Layout>
  )
}
